import { useState, useEffect, useCallback } from "react";
import { get } from "../utils/api";

const useFetchInfo = (url) => {
    const [fechedInfo, setFetchedInfo] = useState({
        data: [],
        isLoading: true,
        error: "",
    });

    const fetchInfoData = useCallback(async () => {
        try {
            // Cookie-based auth: the httpOnly token cookie is sent automatically
            // (axios client has withCredentials: true), so no token is needed here.
            const { data, status } = await get(url);

            if (status >= 400) {
                setFetchedInfo({
                    data: [],
                    isLoading: false,
                    error: data.message,
                });
            } else {
                if (data?.success === true || status === 200) {
                    setFetchedInfo({
                        data: data?.data,
                        isLoading: false,
                        error: "",
                    });
                } else if (status >= 400) {
                    setFetchedInfo({
                        data: [],
                        isLoading: false,
                        error: data?.message,
                    });
                }
            }
        } catch (error) {
            setFetchedInfo({
                data: [],
                isLoading: false,
                error: "Connection Time out",
            });
        }
    }, [url]);

    useEffect(() => {
        fetchInfoData();
    }, [url, fetchInfoData]);

    const { data, isLoading, error } = fechedInfo;
    return { data, isLoading, error };
};

export default useFetchInfo;
